<div class="grid mt-2">
  <i class="pi pi-info-circle ml-2 mt-1" style="font-size: 1rem"></i>
  <p class="ml-2">{{message}}</p>
</div>
<!-- <div *ngIf="moduleType.toLowerCase() === 'meeting'">
    <div class="flex mt-5">
        <i class="mr-5 mt-1 pi pi-user" style="font-size: 1.3rem"></i>
        <p class="text-lg font-semibold">{{moduleData?.createdBy.fullname}}</p>
    </div>
    <div class="flex mt-5">
        <i class="mr-5 mt-1 pi pi-bookmark-fill" style="font-size: 1.3rem"></i>
        <p class="text-lg font-semibold">{{moduleData?.title}}</p>
    </div>
    <div class="flex mt-5">
        <i class="mr-5 mt-1 pi pi-calendar" style="font-size: 1.3rem"></i>
        <div>
            <p class="text-lg font-semibold">{{moduleData?.start}}</p>
            <p class="text-lg font-semibold">{{moduleData?.end}}</p>
        </div>
    </div>
    <div class="flex mt-5">
        <i class="mr-5 mt-1 pi pi-globe" style="font-size: 1.3rem"></i>
        <p class="text-lg font-semibold">{{moduleData?.location}}</p>
    </div>
    <div class="flex mt-5">
        <i class="mr-5 mt-1 pi pi-users" style="font-size: 1.3rem"></i>
        <div class="flex flex-wrap">
            <div *ngFor="let participant of moduleData?.participants" class="mt-2">
                <p-chip class="mr-3 my-chip-gray">
                    <app-avatar-generator [name]="participant.participantId.fullname"></app-avatar-generator>
                    {{participant.participantId.fullname + ' - '}} 
                    <p class="ml-3">{{participant.status}}</p>
                </p-chip>
            </div>
        </div>
    </div>
    <div class="flex justify-content-end mt-8 gap-3" *ngIf="moduleType.toLowerCase() === 'meeting'">
        <p-button label="Accept Invitation" styleClass="p-button-raised p-button-sm" (onClick)="confirmationResponse(true)"></p-button>
        <p-button label="Reject Invitation" styleClass="p-button-raised p-button-danger p-button-sm" (onClick)="confirmationResponse(false)"></p-button>
    </div>
</div> -->
